import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Label } from '../../../app-model/label/label';
import { ApiProxyService } from '../../shared/services/api-proxy.service';
import { BuildParameters } from '../model/export/build-parameters';
import { ConfigService } from 'app/app-services/config.service';

@Injectable()
export class BuildService {
  constructor(private apiProxy: ApiProxyService, private configService: ConfigService) {
  }

  createBuild(buildParameters: BuildParameters): Observable<Label> {
    return this.apiProxy.post(this.configService.apiUrl + 'build', buildParameters);
  }
}
